import { IEquipoDTO } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo"
import { EquipoComponent } from "./EquipoComponent"

interface IEquiposComponent{
    data: IEquipoDTO[]
}


export const EquiposComponent=(props:IEquiposComponent)=>{
    return(
        <>{props.data.map((item,index)=>(
            <EquipoComponent equipo={item} key={index}/>
        ))
          
           
        }
        </>
    )
}